import { IState } from '../../store';
import { IRosreestrInfo } from '../../types/offerData';

export const getRosreestrInfo = (state: IState): IRosreestrInfo | null => state.offerData.rosreestrInfo;
